<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="课程管理" name="first">
        <studyCourse :labelList="labelList"></studyCourse>
      </el-tab-pane>
      <el-tab-pane label="课文管理" name="second">
        <studyText :labelList="labelList"></studyText>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import studyCourse from './studyCourse';
import studyText from './studyText';
import { queryLabel, queryUser } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
  components: {
    studyCourse,
    studyText,
  },
  data() {
    return {
      activeName: 'first',
      // activeName: "second",
      labelList: [],
      groupList: [],
    };
  },
  mounted() {
    this.getQueryLabel();
    // this.getUserGroupList();
  },
  methods: {
    getUserGroupList() {
      let info = {
        userId: localStorage.getItem('userId'),
        needPage: false,
      };

      queryUser(encrypt(JSON.stringify(info))).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          this.groupList = ress[0].groupList;
        }
      });
    },
    getQueryLabel() {
      let info = {
        // page: 1,
        // pageSize: 10,
        needPage: false,
        status: 1,
      };
      var data = encrypt(JSON.stringify(info));
      queryLabel(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          this.labelList = ress;
        } else {
          // this.$message({
          //     showClose: true,
          //     message: res.msg,
          //     type: 'error',
          // });
        }
      });
    },
  },
};
</script>
